var _path, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnterprisetech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.091,
    height: 27.091,
    viewBox: "0 0 27.091 27.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.906,6.991H20.537a2.622,2.622,0,1,0-5.243,0H9.6a4.37,4.37,0,1,0-6.975,0H2.185A2.187,2.187,0,0,0,0,9.176V22.284a2.187,2.187,0,0,0,2.185,2.185H6.991v1.748H5.243v.874h16.6v-.874H20.1V24.469h4.806a2.187,2.187,0,0,0,2.185-2.185V9.176A2.187,2.187,0,0,0,24.906,6.991ZM17.915,5.243a1.748,1.748,0,1,1-1.748,1.748A1.75,1.75,0,0,1,17.915,5.243ZM15.446,7.865a2.622,2.622,0,0,0,.544.9l-3.645,4.009a3.461,3.461,0,0,0-2.956-.36L7.911,8.35a4.365,4.365,0,0,0,.828-.493v.008ZM13.108,15.73a2.622,2.622,0,1,1-2.622-2.622A2.624,2.624,0,0,1,13.108,15.73ZM2.622,4.369a3.5,3.5,0,1,1,3.5,3.5A3.5,3.5,0,0,1,2.622,4.369Zm16.6,21.847H7.865V24.469H19.226Zm6.991-3.933A1.312,1.312,0,0,1,24.906,23.6H2.185A1.312,1.312,0,0,1,.874,22.284v-.437H26.217Zm0-1.311H.874V9.176A1.312,1.312,0,0,1,2.185,7.865H3.5V7.857a4.313,4.313,0,0,0,3.586.771L8.6,12.794a3.5,3.5,0,1,0,4.425.536L16.681,9.3A2.606,2.606,0,0,0,19.47,9.1L22.08,11.38a1.724,1.724,0,0,0-.232.854,1.764,1.764,0,1,0,.839-1.486L20.079,8.468a2.622,2.622,0,0,0,.3-.6h4.522a1.312,1.312,0,0,1,1.311,1.311Zm-3.5-8.739a.874.874,0,1,1,.874.874A.875.875,0,0,1,22.721,12.235Z",
    fill: "#0080ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    transform: "translate(24 19)",
    fill: "#0080ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "translate(20 19)",
    fill: "#0080ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 1,
    transform: "translate(20 17)",
    fill: "#0080ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisetech);
export default __webpack_public_path__ + "static/media/enterprisetech.c642f8d9.svg";
export { ForwardRef as ReactComponent };